var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAirplane(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.148,
    height: 12.263,
    viewBox: "0 0 14.148 12.263",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "airplane",
    d: "M21.039,60.263h-.785a.472.472,0,0,1-.429-.666l1.9-4.193-2.853-.063L17.832,56.6a.809.809,0,0,1-.761.361h-.528a.521.521,0,0,1-.433-.208.528.528,0,0,1-.072-.484l.584-2.093c0-.016.01-.031.016-.047a.011.011,0,0,0,0,0,.436.436,0,0,1-.016-.047l-.585-2.106a.519.519,0,0,1,.075-.473.5.5,0,0,1,.4-.2h.558a.987.987,0,0,1,.766.354l1.019,1.24,2.869-.042-1.9-4.186A.472.472,0,0,1,20.255,48h.793a.737.737,0,0,1,.57.289L25.3,52.769l1.7-.045c.125-.007.47-.009.55-.009,1.629,0,2.6.53,2.6,1.416a1.224,1.224,0,0,1-.857,1.125,4.388,4.388,0,0,1-1.745.293c-.079,0-.424,0-.55-.009l-1.7-.045-3.7,4.481A.737.737,0,0,1,21.039,60.263Z",
    transform: "translate(-16.011 -48)",
    fill: "#63849c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirplane);
export default __webpack_public_path__ + "static/media/airplane.6b3af6783b9702985a5e38590d60170f.svg";
export { ForwardRef as ReactComponent };